import request from '@/utils/request'


// 查询球场标签列表
export function listTag(query) {
  return request({
    url: '/golf/golf-tag/list',
    method: 'get',
    params: query
  })
}

// 查询球场标签分页
export function pageTag(query) {
  return request({
    url: '/golf/golf-tag/page',
    method: 'get',
    params: query
  })
}

// 查询球场标签详细
export function getTag(data) {
  return request({
    url: '/golf/golf-tag/detail',
    method: 'get',
    params: data
  })
}

// 新增球场标签
export function addTag(data) {
  return request({
    url: '/golf/golf-tag/add',
    method: 'post',
    data: data
  })
}

// 修改球场标签
export function updateTag(data) {
  return request({
    url: '/golf/golf-tag/edit',
    method: 'post',
    data: data
  })
}

// 删除球场标签
export function delTag(data) {
  return request({
    url: '/golf/golf-tag/delete',
    method: 'post',
    data: data
  })
}
